import { Component, OnInit } from '@angular/core';
import { NamedMatrixViewModel } from '../../../../../Models/MatrixViewModel';
import { TenantService } from "../../../../../Services";
import { RouterLink } from '@angular/router';

@Component({
    selector: 'aw-matrix-picker',
    templateUrl: './matrix-picker.component.html',
    styleUrls: ['./matrix-picker.component.less'],
    imports: [RouterLink]
})
export class MatrixPickerComponent implements OnInit {
    matrices: NamedMatrixViewModel[] = [];

    constructor(private tenantService: TenantService) { }

    ngOnInit() {
        this.tenantService.getAllMatrices()
            .subscribe(all => this.matrices = all);
    }
}